module.exports = __webpack_public_path__ + "static/pan-e35af05bb2d721b9fe56045976712880.jpg";